import { callApi } from "../api";

export const getPersonInfo = () => callApi("person/information", null, "GET");

export const uploadFiles = (body) => callApi("person/document", body, "POST");

export const getFile = (body) => callApi("person/archive", body, "POST");

export const getQuestions = () => callApi("questions", null, "GET");

export const getAnswers = () => callApi("answers", null, "GET");

export const getAccountAnswers = (body) => callApi("accountAnswers", body, "POST");

export const updateAnswers = (body) => callApi("answers", body, "POST");

export const getLegalContracts = () => callApi("legalContracts", null, "GET");

export const setLegalContract = (body) => callApi("legalContracts", body, "POST");

export const getPersonBankAccount = (body) => callApi("person/bankAccounts", body, "GET");

export const setClientBankAccounts = (body) => callApi("client/bankAccounts", body, "POST");

export const updatePerson = (body) => callApi("onboarding/update", body, "POST");
